import React from 'react';
import cn from 'classnames';

import styles from '../../styles/form.css';
import { SuccessSvg } from '../success-icon';

import type { TSuccessScreen } from './models';

export const SuccessScreen = (props: TSuccessScreen) => {
    const {
        Button,
        buttonText = 'Закрыть',
        className,
        description = 'Мы учтём ваше мнение и улучшим\nработу сайта',
        header = 'Спасибо за вашу оценку!',
        isMobile,
        onClose,
    } = props;

    return (
        <div
            className={cn(styles.feedback, styles.successScreen, className)}
            data-test-id="feedback-form-success-screen"
        >
            <div className={cn(styles.formBody, styles.center)}>
                <SuccessSvg />
                <div className={styles.resultScreenHeader}>{header}</div>
                <div className={styles.resultScreenDesc}>{description}</div>
            </div>
            <div className={isMobile ? styles.buttonSpace : styles.buttonSpaceDesktop}>
                <Button
                    block
                    borderRadius={8}
                    dataTestId="feedback-form-success-close"
                    onClick={onClose}
                    size="s"
                    view="secondary"
                >
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};
